<template>
  <footer>
    <div
      v-if="!isMobile"
      class="copyright-text"
    >
      ©2025 Blibli
    </div>
    <div class="footer__link">
      <a
        href="https://www.blibli.com/faq/tentang-blibli/syarat-ketentuan/"
        target="_blank"
        rel="noopener"
      >
        <span class="footer__link-text">Terms & Conditions <BliIconSiOpenNew width="14" /></span>
      </a>
      <router-link
        :to="{ name: 'PrivacyNotice'}"
        target="_blank"
      >
        <span class="footer__link-text">Privacy Notice <BliIconSiOpenNew width="14" /></span>
      </router-link>
    </div>
  </footer>
</template>

<script src="./js/footer.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';
footer {
  background-color: $blu-color-info-background-med;
  margin: auto;
  padding: 8px 83px;
  border-top: 1px solid #FFFFFF40;
  color: $blu-color-neutral-text-inv;
  font: $blu-text-body-2;
  display: flex;
  align-items: center;
  gap: 40px;

  @include mobile {
    justify-content: center;
    padding-inline: 16px;
    border: none;
  }
}

.footer {
  &__link {
    display: flex;
    gap: 40px;

    @include mobile {
      gap: 0;
    }

    a {
      color: $blu-color-neutral-text-inv;
      @include mobile {
        &:first-child {
          padding-right: 12px;
        }
        &:last-child {
          padding-left: 12px;
          border-left: 1px solid $blu-color-neutral-text-inv-disabled;
        }
      }
    }

    &-text {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}
</style>
